import { useState } from "react";
import SubmitButton from "./SubmitButton";
import { Marketplace } from "../../__generated__/graphql";

const statuses = {
  Paid: "text-green-700 bg-green-50 ring-green-600/20",
  Withdraw: "text-gray-600 bg-gray-50 ring-gray-500/10",
  Overdue: "text-red-700 bg-red-50 ring-red-600/10",
};
const markets = [
  {
    id: Marketplace.Contimo,
    name: "Contimo Marketplace",
    imageUrl: "/images/new_contimo_small.png",
    meta: {
      reach: "2.4M",
      websites: "12",
      description:
        "Select websites from a wide range of publishers across Denmark whom are all part of Contimo's open marketplace",
    },
  },
  {
    id: Marketplace.Step,
    name: "Step",
    imageUrl:
      "https://media.licdn.com/dms/image/D4D0BAQGb7Gc0PNv8yw/company-logo_200_200/0/1706885942971/step_logo?e=2147483647&v=beta&t=-NF1X3J5c4AcDoiGj2RsOvQRcpyCXZMPwiz7bYLK5gU",
    meta: {
      reach: "1.1M",
      dateTime: "2023-01-22",
      websites: "17",
      description:
        "Step, the Danish agency and publisher network, is your connection to premium media within both broad news and niche topics.",
    },
  },
];

export default function MarketSelector({ onChange }) {
  const [loadingMarketPlace, setLoadingMarketPlace] = useState("");

  return (
    <ul
      role="list"
      className="grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-2 xl:gap-x-8 align-bottom"
    >
      {markets.map((market) => (
        <li
          key={market.id}
          className="overflow-hidden rounded-xl border border-gray-200 hover:cursor-pointer"
          onClick={async () => {
            setLoadingMarketPlace(market.id);
            await onChange(market.id);
            setLoadingMarketPlace("");
          }}
        >
          <div className="flex flex-col justify-between border-b border-gray-900/5 bg-gray-50 p-6">
            <div className="flex items-center gap-x-4">
              <img
                src={market.imageUrl}
                alt={market.name}
                className="h-12 w-12 flex-none rounded-lg bg-white object-contain ring-1 ring-gray-900/10"
              />
              <div>
                <div className="text-sm font-medium leading-6 text-gray-900">
                  {market.name}
                </div>
              </div>
            </div>
            <div className="text-sm font-medium leading-6 text-gray-900 mt-4">
              {market.meta.description}
            </div>
          </div>

          {/*<dl className="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
            <div className="flex justify-between gap-x-4 py-3">
              <dt className="text-gray-500">Total Marketplace Reach</dt>
              <dd className="text-gray-700">{market.meta.reach}</dd>
            </div>
            <div className="flex justify-between gap-x-4 py-3">
              <dt className="text-gray-500">Websites</dt>
              <dd className="text-gray-700">{market.meta.websites}</dd>
            </div>
          </dl>*/}

          <div className="flex p-6 items-end justify-end">
            <SubmitButton
              loading={loadingMarketPlace === market.id}
              className="w-full justify-center"
              submitText="Select"
            />
          </div>
        </li>
      ))}
    </ul>
  );
}
